import {
  ProcessList,
  Title,
  Wrapper,
} from './recruitmentProcessCareers.styles';
import { IRecruitmentProcessCareers } from './interfaces';
import { RichText } from 'prismic-reactjs';
import { ProcessItem } from './ProcessItem/ProcessItem';

export const RecruitmentProcessCareers = ({
  titleAs,
  title,
  items,
}: IRecruitmentProcessCareers) => {
  return (
    <Wrapper>
      <Title as={titleAs && titleAs}>{title}</Title>
      <ProcessList>
        {items.map(
          (
            { recruitment_image, recruitment_title, recruitment_description },
            index
          ) => {
            const title = RichText.asText(recruitment_title);
            const description = RichText.asText(recruitment_description);

            return (
              <ProcessItem
                key={title + index}
                itemsLength={items.length}
                title={title}
                description={description}
                image={recruitment_image}
                index={index}
              />
            );
          }
        )}
      </ProcessList>
    </Wrapper>
  );
};
